module.exports = __webpack_public_path__ + "img/weakness.a509ff9d.png";